import React, { useState } from 'react';
import './FifthSection.css';
import indusBanner1 from '../assets/images/indusBanner1.png';
import indusBanner2 from '../assets/images/indusBanner2.png';
import indusBanner3 from '../assets/images/indusBanner3.png';
import indusBanner4 from '../assets/images/indusBanner4.png';
import fifthSection1 from '../assets/images/fifthSection1.png';
import fifthSection2 from '../assets/images/fifthSection2.png';
import fifthSection3 from '../assets/images/fifthSection3.png';
import fifthSection4 from '../assets/images/fifthSection4.png';
import fifthSection5 from '../assets/images/fifthSection5.png';
import leatherPdf from '../assets/pdf/IndusTrade-LeatherSeries.pdf';
import woodPdf from '../assets/pdf/IndusTrade-woodSeries.pdf';
import downloadIcon from '../assets/images/download.svg';
import useScrollAnimation from '../hooks/useScrollAnimation';

const FifthSection = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isDownloadingWood, setIsDownloadingWood] = useState(false);
  const [isDownloadingLeather, setIsDownloadingLeather] = useState(false);
  
  // Scroll animations
  const [woodRef, isWoodVisible] = useScrollAnimation(0.7);
  const [leatherRef, isLeatherVisible] = useScrollAnimation(0.8);
  const woodImages = [
    { src: indusBanner1, alt: 'Wood Furniture 1' },
    { src: indusBanner2, alt: 'Wood Furniture 2' },
    { src: indusBanner3, alt: 'Wood Furniture 3' },
    { src: indusBanner4, alt: 'Wood Furniture 4' },
  ];

  const leatherImages = [
    { src: fifthSection1, alt: 'Leather Furniture 1' },
    { src: fifthSection2, alt: 'Leather Furniture 2' },
    { src: fifthSection3, alt: 'Leather Furniture 3' },
    { src: fifthSection4, alt: 'Leather Furniture 4' },
    { src: fifthSection5, alt: 'Leather Furniture 5' },
  ];

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setSelectedImage(null);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleCloseDialog();
    }
  };

  const handleDownloadWood = async () => {
    setIsDownloadingWood(true);
    try {
      const link = document.createElement('a');
      link.href = woodPdf;
      link.download = 'IndusTrade-woodSeries.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Simulate download time
      await new Promise(resolve => setTimeout(resolve, 2000));
    } catch (error) {
      console.error('Error downloading wood catalogue:', error);
    } finally {
      setIsDownloadingWood(false);
    }
  };

  const handleDownloadLeather = async () => {
    setIsDownloadingLeather(true);
    try {
      const link = document.createElement('a');
      link.href = leatherPdf;
      link.download = 'IndusTrade-LeatherSeries.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      // Simulate download time
      await new Promise(resolve => setTimeout(resolve, 2000));
    } catch (error) {
      console.error('Error downloading leather catalogue:', error);
    } finally {
      setIsDownloadingLeather(false);
    }
  };

  return (
    <section className="fifth-section">
      <div className="fifth-container">
        <div className="fifth-columns">
          {/* First Column - Strength in Wood */}
          <div ref={woodRef} className={`fifth-column wood-column ${isWoodVisible ? 'visible' : ''}`}>
            <h2 className={`fifth-title wood-title text-reveal ${isWoodVisible ? 'visible' : ''}`}>STRENGTH{'\n'}IN WOOD</h2>
            <div className="fifth-image-track wood-track">
              <div className="fifth-image-container">
                {woodImages.map((image, index) => (
                  <img 
                    key={index} 
                    src={image.src} 
                    alt={image.alt} 
                    className={`fifth-image image-reveal ${isWoodVisible ? 'visible' : ''}`}
                    onClick={() => handleImageClick(image)}
                  />
                ))}
                {/* Duplicate images for seamless loop */}
                {woodImages.map((image, index) => (
                  <img 
                    key={`duplicate-${index}`} 
                    src={image.src} 
                    alt={image.alt} 
                    className={`fifth-image image-reveal ${isWoodVisible ? 'visible' : ''}`}
                    onClick={() => handleImageClick(image)}
                  />
                ))}
              </div>
            </div>
            <button 
              className={`download-button wood-download-button fade-in ${isWoodVisible ? 'visible' : ''}`}
              onClick={handleDownloadWood}
              disabled={isDownloadingWood}
            >
              {isDownloadingWood ? (
                <>
                  <span className="download-icon loading">⟳</span>
                  DOWNLOADING...
                </>
              ) : (
                <>
                  <img src={downloadIcon} alt="Download" className="download-icon svg-icon" />
                  DOWNLOAD WOOD CATALOGUE
                </>
              )}
            </button>
          </div>

          {/* Second Column - Elegance in Leather */}
          <div ref={leatherRef} className={`fifth-column leather-column ${isLeatherVisible ? 'visible' : ''}`}>
            <h2 className={`fifth-title leather-title text-reveal ${isLeatherVisible ? 'visible' : ''}`}>ELEGANCE{'\n'}IN LEATHER</h2>
            <div className="fifth-image-track leather-track">
              <div className="fifth-image-container">
                {leatherImages.map((image, index) => (
                  <img 
                    key={index} 
                    src={image.src} 
                    alt={image.alt} 
                    className={`fifth-image image-reveal ${isLeatherVisible ? 'visible' : ''}`}
                    onClick={() => handleImageClick(image)}
                  />
                ))}
                {/* Duplicate images for seamless loop */}
                {leatherImages.map((image, index) => (
                  <img 
                    key={`duplicate-${index}`} 
                    src={image.src} 
                    alt={image.alt} 
                    className={`fifth-image image-reveal ${isLeatherVisible ? 'visible' : ''}`}
                    onClick={() => handleImageClick(image)}
                  />
                ))}
              </div>
            </div>
            <button 
              className={`download-button leather-download-button fade-in ${isLeatherVisible ? 'visible' : ''}`}
              onClick={handleDownloadLeather}
              disabled={isDownloadingLeather}
            >
              {isDownloadingLeather ? (
                <>
                  <span className="download-icon loading">⟳</span>
                  DOWNLOADING...
                </>
              ) : (
                <>
                  <img src={downloadIcon} alt="Download" className="download-icon svg-icon" />
                  DOWNLOAD LEATHER CATALOGUE
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Image Dialog */}
      {isDialogOpen && selectedImage && (
        <div className="image-dialog-overlay" onClick={handleOverlayClick}>
          <div className="image-dialog">
            <div className="dialog-header">
              <h3>Product Preview</h3>
              <button 
                className="dialog-close-btn"
                onClick={handleCloseDialog}
              >
                ×
              </button>
            </div>
            <div className="dialog-content">
              <img 
                src={selectedImage.src} 
                alt={selectedImage.alt}
                className="dialog-image"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default FifthSection;
